export const getConversionHistoryResponse = (state) => state.conversionHistory;